import { useState, useEffect } from "react";
import ServiceStatus from "./ServiceStatus";
import UploadResume from "../../routes/UploadResume";
import Avatar from "@mui/material/Avatar";
import UploadCalendar from "../../routes/UploadCalendar";
import UpdateRequest from "../../routes/UpdateRequest";
import RequestServicePage from "../../routes/ServiceRequest";
import CheckPoints from "../../routes/CheckPoints";
import ServicesView from "./ServicesView";
import axios from "axios";

const OptionPills = ({ func, text, img }) => {
  console.log("text: ", text);
  return (
    <button
      onClick={(e) => func(e)}
      className="flex h-8 w-auto cursor-pointer items-center justify-center space-x-1 rounded-full border-[2px] border-blue-400 bg-white px-2 py-3 text-blue-500 transition-colors hover:bg-blue-50"
    >
      <img src={img} />
      <span className="pt-1 text-xs font-medium">{text}</span>
    </button>
  );
};

const ProfileOptions = [
  {
    text: "Upload Resume",
    img: "/Resume.png",
  },
  {
    text: "Upload Calendar",
    img: "/Calander.png",
  },
  {
    text: "Update Service Price",
    img: "PriceIcon.png",
  },
];

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-50" />
      <div className="relative z-10 max-h-[90vh] overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

function ProfileComponent({
  setOpenPaymentBox,
  setPosts,
  posts,
  visiblePosts,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentComponent, setCurrentComponent] = useState(null);
  
  // State for user data
  const [userInfo, setUserInfo] = useState({
    firstName: '',
    lastName: '',
    points: 0,
    loading: true
  });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const userResponse = await axios.get("https://genz-staging.feeltiptop.com/api/user/getCurrentUserInfo", {
          headers: { Authorization: `Bearer ${token}` }
        });

        const pointsResponse = await axios.get("https://genz-staging.feeltiptop.com/api/user/getUserData", {
          headers: { Authorization: `Bearer ${token}` }
        });

        const userCardResponse = await axios.get("https://genz-staging.feeltiptop.com/api/user/points", {
          headers: { Authorization: `Bearer ${token}` }
        });

        setUserInfo({
          firstName: userResponse.data.firstName || '',
          lastName: userResponse.data.lastName || '',
          points: userCardResponse.data.points || 0,
          loading: false
        });

      } catch (error) {
        console.error("Error fetching user data:", error);
        setUserInfo(prev => ({ ...prev, loading: false }));
      }
    };

    fetchUserData();
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentComponent(null);
  };

  const handleSetCurrentComponent = (e) => {
    e.preventDefault();
    const serviceTitle = e.target.innerText;
    console.log("current service title: ", serviceTitle);

    switch (serviceTitle) {
      case "360 Points":
        setCurrentComponent(<CheckBalance key="check-points" />);
        break;
      case "Request Service":
        setCurrentComponent(
          <RequestServicePage
            key="service-request"
            serviceTitle={serviceTitle}
            onClose={closeModal}
          />
        );
        break;
      case "Update Service Price":
        setCurrentComponent(
          <UpdateRequest
            onClose={closeModal}
            key="update-request"
            serviceTitle={serviceTitle}
          />
        );
        break;
      case "Upload Resume":
        setCurrentComponent(
          <UploadResume onClose={closeModal} key="upload-resume" />
        );
        break;
      case "Upload Calendar":
        setCurrentComponent(
          <UploadCalendar onClose={closeModal} key="upload-calendar" />
        );
        break;
      case "View Referral Link":
        setCurrentComponent(<ReferralLink onClose={closeModal} />);
        break;
      case "Completed Services":
        setCurrentComponent(
          <ServicesView onClose={closeModal} key="completed-services" />
        );
        break;
      case "Service Status":
        setCurrentComponent(
          <ServiceStatus onClose={closeModal} key="service-status" />
        );
        break;
      default:
        setCurrentComponent(<CheckPoints onClose={closeModal} key="points" />);
    }
    setIsModalOpen(true);
  };

  const getAvatarLetter = () => {
    if (userInfo.firstName) {
      return userInfo.firstName.charAt(0).toUpperCase();
    }
    return 'U';
  };

  const formatPoints = (points) => {
    return points.toLocaleString();
  };

  const getDisplayName = () => {
    if (userInfo.firstName) {
      return `Hello ${userInfo.firstName}!`;
    }
    return "Hello User!";
  };

  if (userInfo.loading) {
    return (
      <div className="box-border grid h-[184px] w-full grid-cols-8 gap-2 rounded-[16px] px-[16px] pt-[8px] shadow-md">
        <div className="col-span-8 flex items-center justify-center">
          <div className="text-gray-500">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="box-border grid h-[184px] w-full grid-cols-8 gap-2 rounded-[16px] px-[16px] pt-[8px] shadow-md">
      <Avatar>{getAvatarLetter()}</Avatar>
      <div className="col-span-7 mt-3 h-full w-full flex-1 gap-y-24">
        <div
          id="greetings-div"
          className="items-left flex flex-col justify-center"
        >
          <div
            id="profile-greeting text-left"
            className="flex items-center justify-between"
          >
            <h3 className="text-left text-[20px] font-normal">
              {getDisplayName()}
            </h3>

            <button
              onClick={handleSetCurrentComponent}
              href=""
              className="font-semibold text-[#107BEF] underline"
            >
              Completed Services
            </button>
          </div>
        </div>

        <div className="mt-2 flex items-center justify-between">
          <div className="flex items-center justify-center space-x-1">
            <img src="/PayIcon.svg" />
            <h3 className="mb-0 mt-1 pb-0 text-[16px] font-normal text-[#107BEF]">
              Available points: {formatPoints(userInfo.points)}
            </h3>
          </div>
          <button
            onClick={(e) => handleSetCurrentComponent(e)}
            className="flex items-center space-x-2"
          >
            <img src="/AddPoints.png" />
            <span className="hidden">Add Points</span>
          </button>
        </div>

        <hr className="m-1 h-2 border-2 border-gray-300" />
        <div className="flex h-12 w-auto items-center justify-between">
          {ProfileOptions.map((optionsObj, index) => (
            <OptionPills
              key={index}
              func={handleSetCurrentComponent}
              text={optionsObj.text}
              img={optionsObj.img}
            />
          ))}
          <div className="border-l-2 border-gray-700"></div>
          <button
            id="request-service"
            onClick={(e) => handleSetCurrentComponent(e)}
            className="rounded-[16px] bg-[#107BEF] px-4 py-2 text-center text-white"
          >
            Request Service
          </button>
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {currentComponent}
      </Modal>
    </div>
  );
}

export default ProfileComponent;